export const ANIMATION_CLASSES = {
    fadeIn: 'animate-fade-in',
    fadeInRight: 'animate-fade-in-right',
    fadeInDown: 'animate-fade-in-down',
    fadeInLeft: 'animate-fade-in-left',
    fadeInTop: 'animate-fade-in-top',
    fadeOut: 'animate-fade-out',
    fadeOutRight: 'animate-fade-out-right',
    fadeOutDown: 'animate-fade-out-down',
    fadeOutLeft: 'animate-fade-out-left',
    fadeOutTop: 'animate-fade-out-top',
    slideInRight: 'animate-slide-in-right',
    slideOutRight: 'animate-slide-out-right',
    zoomIn: 'animate-zoom-in',
    zoomOut: 'animate-zoom-out',
};
